import { IRoomData } from "src/common/records/Room";
import { List } from "immutable";
import { ActionsUnion, createAction } from "src/common/reducers/UtilsTypes";

export const RECEIVE_ROOM = "@rooms/RECEIVE_ROOM";
export const EDIT_ROOM = "@rooms/EDIT_ROOM";
export const RESET_ROOMS = "@rooms/RESET_ROOMS";
export const UPDATE_FORM = "@rooms/UPDATE_FORM";
export const RESET_ROOM = "@rooms/RESET_ROOM";

export const RoomActions = {
  receiveRoom: (room: Partial<IRoomData>) => createAction(RECEIVE_ROOM, { room }),
  editRoom: (room: Partial<IRoomData>) => createAction(EDIT_ROOM, { room }),
  updateForm: (event: { rootPath: any; name: string; value: any }) => createAction(UPDATE_FORM, { event }),
  resetRoom: (roomId: number) => createAction(RESET_ROOM, { roomId }),
};

export type RoomActions = ActionsUnion<typeof RoomActions>;
